import { useMemo, useState } from 'react'
import {
  Bell,
  CheckCircle,
  Clock,
  Ticket,
  ArrowRight,
  Check,
  FunnelSimple,
} from '@phosphor-icons/react'
import { Link } from 'react-router-dom'
import { useLang } from '../../context/LangContext'

const ALL_NOTIFICATIONS = Array.from({ length: 100 }).map((_, index) => {
  const no = index + 1
  const types = ['status', 'reply', 'resolved']
  const type = types[index % types.length]

  return {
    id: no,
    type,
    titleKey:
      type === 'status'
        ? 'notifStatusTitle'
        : type === 'reply'
          ? 'notifReplyTitle'
          : 'notifResolvedTitle',
    message:
      type === 'status'
        ? `#TKT-${String(50 - (index % 40)).padStart(3, '0')} has been updated to In progress.`
        : type === 'reply'
          ? `Support staff replied to your ticket update.`
          : `#TKT-${String(50 - (index % 40)).padStart(3, '0')} has been resolved.`,
    time: index < 2 ? 'Today' : `${index + 1} days ago`,
    unread: index < 8,
    icon:
      type === 'status'
        ? Clock
        : type === 'reply'
          ? Ticket
          : CheckCircle,
  }
})

const PAGE_SIZE = 20

export default function NotificationsPage() {
  const { t } = useLang()
  const [showUnreadOnly, setShowUnreadOnly] = useState(false)
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  const filteredNotifications = useMemo(() => {
    return ALL_NOTIFICATIONS.filter((item) => {
      if (!showUnreadOnly) return true
      return item.unread
    })
  }, [showUnreadOnly])

  const visibleNotifications = filteredNotifications.slice(0, visibleCount)
  const unreadCount = ALL_NOTIFICATIONS.filter((item) => item.unread).length
  const hasMore = visibleCount < filteredNotifications.length

  const handleToggleUnread = () => {
    setShowUnreadOnly((current) => !current)
    setVisibleCount(PAGE_SIZE)
  }

  return (
    <div className="page page--wide notifications-page">
      <div className="notifications-hero">
        <div className="notifications-hero__icon">
          <Bell size={28} />
        </div>

        <div>
          <span className="notifications-hero__eyebrow">{unreadCount} unread updates</span>
          <h1>{t('notifications')}</h1>
          <p>{t('notificationsSub')}</p>
        </div>

        <button className="btn btn--primary notifications-hero__action">
          <Check size={16} /> {t('markAllRead')}
        </button>
      </div>

      <div className="notifications-layout">
        <main>
          <div className="notifications-toolbar">
            <button
              type="button"
              className={`btn ${showUnreadOnly ? 'btn--primary' : 'btn--ghost'}`}
              onClick={handleToggleUnread}
            >
              <FunnelSimple size={16} />
              {showUnreadOnly ? 'Showing unread only' : 'Unread only'}
            </button>

            <span className="notifications-toolbar__count">
              Showing {visibleNotifications.length} of {filteredNotifications.length}
            </span>
          </div>

          <div className="notification-list notification-list--card">
            {visibleNotifications.map((item) => {
              const Icon = item.icon

              return (
                <Link
                  to="/tickets/49"
                  className={`notification-card ${item.unread ? 'notification-card--unread' : ''}`}
                  key={item.id}
                >
                  <div className={`notification-card__icon notification-card__icon--${item.type}`}>
                    <Icon size={22} />
                  </div>

                  <div className="notification-card__body">
                    <div className="notification-card__topline">
                      <h2 className="notification-card__title">{t(item.titleKey)}</h2>
                      {item.unread && <span className="notification-card__dot" />}
                    </div>

                    <p className="notification-card__message">{item.message}</p>
                    <p className="notification-card__time">{item.time}</p>
                  </div>

                  <div className="notification-card__arrow">
                    <ArrowRight size={18} />
                  </div>
                </Link>
              )
            })}
          </div>

          {hasMore && (
            <div className="load-more-panel">
              <button
                type="button"
                className="btn btn--ghost btn--full"
                onClick={() => setVisibleCount((count) => count + PAGE_SIZE)}
              >
                Load more notifications
              </button>
            </div>
          )}
        </main>

        <aside className="notifications-side">
          <div className="notifications-side-card">
            <h3>Notification Summary</h3>
            <div>
              <span>Unread</span>
              <strong>{unreadCount}</strong>
            </div>
            <div>
              <span>Total</span>
              <strong>{ALL_NOTIFICATIONS.length}</strong>
            </div>
            <div>
              <span>Loaded</span>
              <strong>{visibleNotifications.length}</strong>
            </div>
          </div>

          <div className="notifications-side-card">
            <h3>Tip</h3>
            <p>Older notifications can be archived automatically after 90–180 days.</p>
          </div>
        </aside>
      </div>
    </div>
  )
}
